"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSemanticTextComponent = void 0;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _utils = require("../utils");
var _Text = _interopRequireDefault(require("./Text"));
const createSemanticTextComponent = (tag, defaultProps) => {
  // Capitalize the first letter of the tag name
  const componentName = "".concat(tag.charAt(0).toUpperCase()).concat(tag.substring(1));

  // TODO: In 5.x, if Typescript is upgraded to 5.x remove the 'as unknown' assertion
  const HeadingComponent = _Text.default.withComponent(tag, process.env.NODE_ENV === "production" ? {
    target: "e16nynr70"
  } : {
    target: "e16nynr70",
    label: "HeadingComponent"
  });

  // Variant font size takes priority over Text's default fontSize value
  const textDefaultProps = (0, _utils.omit)(_Text.default.defaultProps, !!defaultProps.variant ? ['fontSize'] : []);
  HeadingComponent.defaultProps = {
    ...textDefaultProps,
    ...defaultProps
  };
  const DocumentedHeadingComponent = (0, _stencilReactDesc.describe)(HeadingComponent).description("Text with ".concat(tag, " tag"));
  DocumentedHeadingComponent.propTypes = {
    ..._Text.default.describedPropTypes
  };
  const ComponentWithTestAttributes = (0, _utils.withTestAttributes)({
    component: "Stencil".concat(componentName)
  })(DocumentedHeadingComponent);
  ComponentWithTestAttributes.displayName = componentName;
  return ComponentWithTestAttributes;
};
exports.createSemanticTextComponent = createSemanticTextComponent;